const thoughtBubbleUtils = {
    minCogWidth: 10,
    maxCogWidth: 20,
    minCogHeight: 10,
    maxCogHeight: 20,

    getPath (shapeModel) {
        const points = this.getPoints(shapeModel);
        const path  = this.createPath(points, shapeModel);

        return path;
    },
    createPath ( points, shapeModel) {
        var data = `M${points[0].x - shapeModel.x},${points[0].y - shapeModel.y}`;
        const length = points.length;
        var i;
        var point;

        for (i=1; i<length; i=i+2) {
            point = points[i];

            point.x = point.x - shapeModel.x;
            point.y = point.y - shapeModel.y;
            data += 'Q' + point.x + ',' + point.y;

            point = points[i + 1];

            point.x = point.x - shapeModel.x;
            point.y = point.y - shapeModel.y;
            data += ',' + point.x + ',' + point.y;
        }

        return data;
    },
    randomIntFromInverval (min, max) {
        return Math.floor(Math.random()*(max-min+1)+min);
    },
    getNextStep (point, direction, shapeModel) {
        const {x, y, width, height} = shapeModel;
        const minX = Math.min(x, x + width);
        const maxX = Math.max(x, x + width);
        const minY = Math.min(y, y + height);
        const maxY = Math.max(y, y + height);
        let nextStep;

        switch (direction) {
            case 'right': {
                nextStep = this.randomIntFromInverval(this.minCogWidth, this.maxCogWidth) + point.x;

                if (nextStep < maxX) {
                    if (maxX - nextStep < this.minCogWidth / 2)
                        nextStep = maxX;

                    return {x: nextStep, y: point.y};
                } else {
                    return {x: maxX, y: minY};
                }
                break;
            }
            case 'down': {
                nextStep = this.randomIntFromInverval(this.minCogWidth, this.maxCogWidth) + point.y;

                if (nextStep < maxY) {
                    if (maxY - nextStep < this.minCogWidth / 2)
                        nextStep = maxY;

                    return {x: point.x, y: nextStep};
                } else {
                    return {x: maxX, y: maxY};
                }
                break;
            }
            case 'left': {
                nextStep = point.x - this.randomIntFromInverval(this.minCogWidth, this.maxCogWidth);

                if (nextStep > minX) {
                    if (nextStep - minX < this.minCogWidth / 2)
                        nextStep = minX;

                    return {x: nextStep, y: point.y};
                } else {
                    return {x: minX, y: maxY};
                }
                break;
            }
            case 'up': {
                nextStep = point.y - this.randomIntFromInverval(this.minCogWidth, this.maxCogWidth);

                if (nextStep > minY) {
                    if (nextStep - minY < this.minCogWidth / 2)
                        nextStep = minY;

                    return {x: point.x, y: nextStep};
                } else {
                    return {x: minX, y: minY};
                }
                break;
            }
        }
    },
    getPoints (shapeModel) {
        const {x, y, width, height} = shapeModel;
        let direction = 'right';
        let points = [];
        let currentPoint = {x, y};
        points.push(currentPoint);

        do {
            let nextPoint = this.getNextStep(currentPoint, direction, shapeModel);
            let cogTip;

            switch (direction) {
                case 'right': {
                    cogTip = {x: (currentPoint.x + nextPoint.x) / 2, y: currentPoint.y - this.randomIntFromInverval(this.minCogHeight, this.maxCogHeight)};
                    points.push(cogTip);
                    points.push({x:nextPoint.x, y:nextPoint.y});

                    if (nextPoint.x == x + width)
                        direction = 'down';
                    break;
                }
                case 'down': {
                    cogTip = {x: currentPoint.x + this.randomIntFromInverval(this.minCogHeight, this.maxCogHeight), y: (currentPoint.y + nextPoint.y) / 2};
                    points.push(cogTip);
                    points.push({x:nextPoint.x, y:nextPoint.y});

                    if (nextPoint.y == y + height)
                        direction = 'left';
                    break;
                }
                case 'left': {
                    cogTip = {x: (currentPoint.x + nextPoint.x) / 2, y: currentPoint.y + this.randomIntFromInverval(this.minCogHeight, this.maxCogHeight)};
                    points.push(cogTip);
                    points.push({x:nextPoint.x, y:nextPoint.y});

                    if (nextPoint.x == x)
                        direction = 'up';
                    break;
                }
                case 'up': {
                    cogTip = {x: currentPoint.x - this.randomIntFromInverval(this.minCogHeight, this.maxCogHeight), y: (currentPoint.y + nextPoint.y) / 2};
                    points.push(cogTip);
                    points.push({x:nextPoint.x, y:nextPoint.y});

                    if (nextPoint.y == y)
                        direction = 'right';
                    break;
                }
            }

            currentPoint = nextPoint;
        } while (currentPoint.x != x || currentPoint.y != y);

        return points;
    },
    getStemPoints (shapeModel) {
        const center = {x: shapeModel.x + shapeModel.width / 2, y: shapeModel.y + shapeModel.height / 2};
        const stemStartLocation = {x: (center.x + shapeModel.cx) / 2, y: (center.y + shapeModel.cy) / 2};
        const xStep = (shapeModel.cx - stemStartLocation.x) / 2;
        const yStep = (shapeModel.cy - stemStartLocation.y) / 2;
        const radius = Math.abs(Math.min(shapeModel.width, shapeModel.height)) * 15/100;
        let stemPoints = [];
        let stemRadius = [];

        stemPoints.push({x: stemStartLocation.x - shapeModel.x, y: stemStartLocation.y - shapeModel.y});
        stemPoints.push({x: stemStartLocation.x + xStep - shapeModel.x, y: stemStartLocation.y + yStep - shapeModel.y});
        stemPoints.push({x: shapeModel.cx - shapeModel.x, y: shapeModel.cy - shapeModel.y});

        stemRadius.push(radius);
        stemRadius.push(radius / 2);
        stemRadius.push(radius / 3);

        return {points: stemPoints, radius: stemRadius};
    }
};

export default thoughtBubbleUtils;



/** WEBPACK FOOTER **
 ** ./src/components/slide/shapes/utils/ThoughtBubbleUtils.js
 **/